import { GridPricing, Product } from '@setvi/shared/interfaces';
import { STextProps } from '@setvi/shared/components/sui/stext';
import { Loader } from './components';
import { FullContent } from './components/full-content';

interface FullPriceProps {
  product: Product;
  loading?: boolean;
  pricing: GridPricing[];
  fontSize?: STextProps['size'];
}

export const FullPrice = ({
  product,
  pricing,
  loading,
  fontSize
}: FullPriceProps) => {
  if (loading) return <Loader />;

  return (
    <FullContent
      product={product}
      pricing={pricing}
      fontSize={fontSize}
      style={{ rowGap: fontSize === 'sm' && '4px' }}
    />
  );
};
